export default function VoxelBackground() {
  const blocks = [
    // Ziemia - dolny pas
    { x: 0, y: 85, w: 100, h: 15, color: "#5D4037" },
    { x: 0, y: 80, w: 100, h: 5, color: "#4CAF50" },
    
    // Bloczki trawy
    { x: 2, y: 73, w: 8, h: 8, color: "#4CAF50" },
    { x: 12, y: 70, w: 10, h: 11, color: "#4CAF50" },
    { x: 25, y: 74, w: 7, h: 7, color: "#4CAF50" },
    { x: 45, y: 71, w: 9, h: 10, color: "#4CAF50" },
    { x: 60, y: 73, w: 8, h: 8, color: "#4CAF50" },
    { x: 75, y: 70, w: 12, h: 11, color: "#4CAF50" },
    { x: 88, y: 74, w: 10, h: 7, color: "#4CAF50" },

    // Kamienie
    { x: 5, y: 75, w: 4, h: 4, color: "#9E9E9E" },
    { x: 35, y: 76, w: 5, h: 4, color: "#757575" },
    { x: 68, y: 75, w: 4, h: 5, color: "#9E9E9E" },
    { x: 90, y: 76, w: 5, h: 4, color: "#757575" },

    // Drzewa - pnie
    { x: 10, y: 55, w: 4, h: 20, color: "#795548" },
    { x: 40, y: 58, w: 4, h: 17, color: "#795548" },
    { x: 70, y: 53, w: 4, h: 22, color: "#795548" },

    // Drzewa - liście (voxel style)
    { x: 6, y: 42, w: 12, h: 6, color: "#2E7D32" },
    { x: 8, y: 36, w: 8, h: 7, color: "#388E3C" },
    { x: 10, y: 30, w: 4, h: 7, color: "#43A047" },

    { x: 36, y: 45, w: 12, h: 6, color: "#2E7D32" },
    { x: 38, y: 39, w: 8, h: 7, color: "#388E3C" },
    { x: 40, y: 33, w: 4, h: 7, color: "#43A047" },

    { x: 66, y: 40, w: 12, h: 6, color: "#2E7D32" },
    { x: 68, y: 34, w: 8, h: 7, color: "#388E3C" },
    { x: 70, y: 28, w: 4, h: 7, color: "#43A047" },

    // Dom
    { x: 20, y: 60, w: 15, h: 20, color: "#EF9A9A" },
    { x: 18, y: 52, w: 19, h: 9, color: "#E53935" },
    { x: 26, y: 68, w: 4, h: 12, color: "#795548" },
    { x: 22, y: 63, w: 5, h: 5, color: "#90CAF9" },
    { x: 28, y: 63, w: 5, h: 5, color: "#90CAF9" },

    // Góry w tle
    { x: 0, y: 40, w: 20, h: 40, color: "#78909C" },
    { x: 15, y: 30, w: 20, h: 50, color: "#607D8B" },
    { x: 55, y: 35, w: 20, h: 45, color: "#78909C" },
    { x: 70, y: 25, w: 20, h: 55, color: "#607D8B" },
    { x: 85, y: 38, w: 20, h: 42, color: "#78909C" },

    // Śnieg na górach
    { x: 15, y: 28, w: 10, h: 5, color: "#FFFFFF" },
    { x: 17, y: 24, w: 6, h: 5, color: "#FFFFFF" },
    { x: 70, y: 23, w: 10, h: 5, color: "#FFFFFF" },
    { x: 72, y: 19, w: 6, h: 5, color: "#FFFFFF" },

    // Chmury
    { x: 5, y: 8, w: 15, h: 6, color: "#FFFFFF" },
    { x: 8, y: 5, w: 9, h: 5, color: "#FFFFFF" },
    { x: 35, y: 12, w: 12, h: 5, color: "#FFFFFF" },
    { x: 37, y: 9, w: 8, h: 4, color: "#FFFFFF" },
    { x: 65, y: 6, w: 14, h: 6, color: "#FFFFFF" },
    { x: 68, y: 3, w: 8, h: 4, color: "#FFFFFF" },

    // Słońce
    { x: 88, y: 5, w: 8, h: 8, color: "#FFD600" },
    { x: 86, y: 7, w: 12, h: 4, color: "#FFD600" },
    { x: 90, y: 3, w: 4, h: 12, color: "#FFD600" },

    // Kwiaty
    { x: 33, y: 78, w: 2, h: 2, color: "#E91E63" },
    { x: 50, y: 79, w: 2, h: 2, color: "#9C27B0" },
    { x: 82, y: 78, w: 2, h: 2, color: "#FF5722" },
  ];

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 0,
      pointerEvents: "none",
      overflow: "hidden",
      background: "#87CEEB",
    }}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
      >
        {blocks.map((block, i) => (
          <rect
            key={i}
            x={block.x}
            y={block.y}
            width={block.w}
            height={block.h}
            fill={block.color}
            stroke="rgba(0,0,0,0.1)"
            strokeWidth="0.3"
          />
        ))}
      </svg>
    </div>
  );
}